import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useMembersAvatarRow } from "@/react/hooks/members/useMembersAvatarRow";
import type { SpaceGroup } from "@circle-react/types";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Button } from "@circle-react-uikit/Button";
import { Loader } from "@circle-react-uikit/Loader";
import { MembersAvatarRow } from "@circle-react-uikit/MembersAvatarRow";
import { ManageSpaceGroupActionsV3 } from "./ManageSpaceGroupActionsV3";
import { useSpaceGroupHeader } from "./useSpaceGroupHeader";

export interface SpaceGroupHeaderActionsProps {
  spaceGroup: SpaceGroup;
}

export const SpaceGroupHeaderActions = ({
  spaceGroup,
}: SpaceGroupHeaderActionsProps) => {
  const history = useHistory();
  const scopeResults = { space_groups: spaceGroup.slug };
  const { members, isLoading, canSeeMembersDirectory } =
    useMembersAvatarRow(scopeResults);
  const { spaceModal, canManage } = useSpaceGroupHeader({
    spaceGroup,
  });
  const shouldHideMembersCount = spaceGroup?.hide_members_count;

  const goToMembersDirectoryForSpaceGroup = () => {
    if (canSeeMembersDirectory) {
      history.push(`/members?filter[space_groups]=${spaceGroup.slug}`);
    }
  };

  return (
    <div className="hidden items-center gap-5 lg:flex">
      {!shouldHideMembersCount && (
        <>
          {isLoading ? (
            <Loader />
          ) : (
            <TippyV2
              content={t("see_all_members")}
              disabled={!canSeeMembersDirectory}
            >
              <button
                type="button"
                disabled={!canSeeMembersDirectory}
                onClick={goToMembersDirectoryForSpaceGroup}
              >
                <MembersAvatarRow
                  members={members || []}
                  amountToShow={3}
                  totalCount={spaceGroup.active_members_count}
                />
              </button>
            </TippyV2>
          )}
        </>
      )}
      {canManage && (
        <>
          <Button
            type="button"
            large
            onClick={() => spaceModal.show({ spaceGroupId: spaceGroup.id })}
          >
            {t("add_space")}
          </Button>
          <ManageSpaceGroupActionsV3 spaceGroup={spaceGroup} />
        </>
      )}
    </div>
  );
};
